var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"thanks-page-title text-center font-weight-bold",style:(_vm.$mq === 'sp' ? 'font-size:20px' : 'font-size:24px')},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }